define('models/SupportCenterModel',['underscore','jquery','site_vars','ObjectModel','LocalStorage',
    'string',
    'UrlFactory',
    'app',
    'ApiRequest',
    'models/zendesk/ArticleModel',
    'models/zendesk/CategoryCollection',
    'models/zendesk/ArticleCollection',
    'models/zendesk/FieldCollection',
    'models/zendesk/FormCollection',
    'models/zendesk/SectionCollection',
],function (_,$,site_vars, ObjectModel,LocalStorage,
    S,
    UrlFactory,
    app,
    ApiRequest,
    ZendeskArticleModel,
    ZendeskCategoryCollection,
    ZendeskArticleCollection,
    ZendeskFieldCollection,
    ZendeskFormCollection,
    ZendeskSectionCollection
) {


    var singleton,
        searchJXHR,
        articles = new ZendeskArticleCollection(),
        sections = new ZendeskSectionCollection(),
        categories = new ZendeskCategoryCollection(),
        forms = new ZendeskFormCollection(),
        fields = new ZendeskFieldCollection(),
        _BUNDLE_COLLECTIONS_ = _([
            articles,sections,categories,forms,fields
        ]);
    var SupportCenterPrototype = {

        identifier:'id_zendesk',
        route:'apiZendeskBundle',
        name:'SupportCenterModel',

        defaults: {
            dataReady: false,
            valid: true,
            type: 'root', // current view type
            id: '', // current view ressource id
            searchPending:false,
            inputSearch:'',
        },

        initialize:function(){

            singleton = this;

            ObjectModel.prototype.initialize.apply(this,arguments);

            function Setup(){
                _BUNDLE_COLLECTIONS_.each(function(collection){
                    collection.reset(singleton.get(collection.bundleId));
                    collection.supportCenter = singleton;
                });
                singleton.validate();
                singleton.on('change:id,change:type',singleton.validate);
                singleton.set('dataReady',true);
                singleton.trigger('dataReady');
            }


            singleton.once('sync',Setup);
            singleton.fetch();

            singleton.on('change:type',singleton.onChangeType);

        },

        validate:function(){
            try{
                singleton.getBreadcrumb();
            }catch(err){
                singleton.set({'type':'root','id':''});
                app.alert();
            }
        },

        onChangeType:function(m,newType){
            switch (newType){
                case 'search':
                case 'category':
                case 'article':
                    // do nothing
                    break;
                default :
                    // le type par défaut est "root"
                case null:
                case '':
                    m.attributes.type = 'root';
                    break;
            }
        },

        getInputSearch:function(){
            return S(singleton.get('inputSearch') || '').trim().s;
        },

        isEmptySearch:function(){
            return singleton.getInputSearch().length == 0;
        },

        getSearchTitle:function(){
            var title = '',
                inputSearch = singleton.getInputSearch(),
                searchCount = singleton.getSearchCount(),
                translationContext = 'SupportCenter';
            if(singleton.isEmptySearch()){
                title = app.t('Saisissez votre demande',translationContext,inputSearch);
            }else if(searchCount<=0){
                title = app.t('pas de résultat pour la recherche “%s”',translationContext, inputSearch)
            }else{
                title = app.t('%s résultats pour la recherche “%s”',translationContext, [searchCount,inputSearch])
            }
            return title;
        },

        getType:function(){
            // retourne le type de vue à afficher
            return singleton.get('type');
        },

        getUrl:function(){
            return UrlFactory.getUrl('supportCenter');
        },

        getBreadcrumb:function(){
            var type = singleton.getType(),
                dataReady = singleton.get('dataReady'),
                breadcrumbLevels = ['root','category','article'],
                breadcrumbItems = [],
                item,
                level = type === 'search' ? 1 : _(breadcrumbLevels).indexOf(type);

            function Item(label,url){
                return {
                    label: label,
                    url: url,
                    last:false
                };
            }

            if(type === 'root' || dataReady !==true) {
                level = app.isDesktop() ? 1 : 0;
            }
            {
                for (var i = 0; i <= level; i++) {
                    switch (i) {
                        case 0:
                            item = Item(
                                app.t("Besoin d'aide ?", 'SupportCenter'),
                                UrlFactory.getUrl('supportCenter')
                            );
                            break;
                        case 1:
                            if(type === 'search') {
                                item = Item(
                                    app.t('Rechercher', 'UI'),
                                    UrlFactory.getUrl('supportCenterSearch', {type: 'search'})
                                );
                            }else{
                                var category = singleton.getCurrentCategory();
                                item = category ? Item(
                                    category.getName(),
                                    category.getUrl()
                                ):Item('','#');
                            }
                            break;
                        case 2:
                            var article = singleton.getCurrentArticle();
                            item = article ? Item(
                                article.getName(),
                                article.getUrl()
                            ) : Item('','#');
                            if (article.isDirect()) {
                                // on supprime une étape si l'article est direct
                                breadcrumbItems.pop();
                            }
                            break;
                    }
                    item.level = level-i;
                    breadcrumbItems.push(item);
                }
            }
            var n = breadcrumbItems.length;
            if(n>1){
                breadcrumbItems[n-1].last = true;
            }
            return _(breadcrumbItems);
        },

        self:function(){
            return singleton;
        },

        isDirect:function(){
            var article = singleton.getCurrentArticle();
            return (article && article.isDirect()) === true;
        },

        getCurrentCategory:function(){
            var type = singleton.getType(),
                id = singleton.get('id'),
                category, article;
            switch(type){
                case 'category' :
                    category = singleton.getCategory(id);
                    break;
                case 'article':
                    article = singleton.getArticle(id);
                    category = article.getCategory();
                    break;
            }
            return category;
        },
        getCurrentArticle:function(){
            var type = singleton.getType(),
                id = singleton.get('id'),
                article;
            if(type == 'article'){
               article = singleton.getArticle(id);
            }
            return article;
        },

        getPromotedArticles:function(){
            //
            // génère un pseudo article pour la home et les vues sans article
            //
            var promotedArticles = [];

            singleton.getArticles().each(function(article){
               if(article.get('promoted')){
                   promotedArticles.push(article);
               }
            });
            return _(promotedArticles);
        },

        getCategories:function() {
            return categories;
        },

        getSections:function() {
            return sections;
        },

        getArticles:function() {
            return articles;
        },

        getArticle:function(articleId) {
            return articles.get(articleId);
        },

        getForms:function() {
            return forms;
        },

        getForm:function(formId){
            return forms.get(formId);
        },

        getFields:function() {
            return fields
        },

        getField:function(fieldId){
            return fields.get(fieldId);
        },

        getSectionsByCategoryId: function(categoryId) {
            return sections.findWhere({category_id: categoryId});
        },

        getSection: function(sectionId) {
            return sections.get(sectionId);
        },

        getCategory: function(categoryId) {
            return categories.get(categoryId);
        },
        getCategoryNameByCategoryId: function(categoryId) {
            return categories.get(categoryId).get('name');
        },

        search:function(){

            singleton.set('searchPending',true);
            var ZDURL = app.c('ZDURL',app.c('_ZDURL_','https://sushishopgroup.zendesk.com/api/v2'));
            searchJXHR = $.ajax({
                url:ZDURL+'/help_center/articles/search.json',
                method:'GET',
                data:{
                    query:singleton.getInputSearch()
                }
            }).done(function(data){
                singleton.set({
                    searchResults:data,
                    searchPending:false
                },data);
            }).fail(function(){
                singleton.set({
                    searchResults:false,
                    searchPending:false
                });
            });
        },

        getSearchCount:function(){
            var searchResults = singleton.get('searchResults');
            return searchResults ? searchResults.count : 0;
        },

        getSearchResults:function(){
            var results = [],
                searchResults = singleton.get('searchResults');
            _(searchResults.results).each(function(result){
                result.href= UrlFactory.getUrl('supportCenterResource',{type:result.result_type,id:result.id});
                results.push(result);
            });
            return _(results);
        },
        requestContactForm:function(data,dataImage,Success,Error){
            var _ZENDESK_SEND_CONTACT_ROUTE_ = 'ZendeskSendContact';

                // fonction de requete principale
            // qui peut être exécutée en 2 temps, si image
            function Request() {
                ApiRequest(_ZENDESK_SEND_CONTACT_ROUTE_, data, {params: ''})
                    .done(Success)
                    .fail(Fail)
            }

            // fonction de requete d'upload
            function RequestImage() {
                ApiRequest(_ZENDESK_SEND_CONTACT_ROUTE_, dataImage, {
                        params: '?upload=true'
                    }, {
                        contentType: false, // obligatoire pour de l'upload
                        processData: false, // obligatoire pour de l'upload
                    }
                ).done(function (responseJson) {
                    var id_image = responseJson.id_image;
                    data.id_image = id_image;
                    Request();
                }).fail(Fail);
            }

            // en cas d'erreur diverse lors de la soumission du formulaire
            function Fail(response) {
                var responseJSON = response.responseJSON;
                Error((responseJSON && responseJSON.error)||false);
            }

            if (dataImage) {
                // Upload Request
                RequestImage();
            } else {
                // Request without upload
                Request();
            }
        },
    };

    var SupportCenter = ObjectModel.extend(LocalStorage).extend(SupportCenterPrototype);

    SupportCenter.getInstance = function(){
          if(!singleton){
              singleton = new SupportCenter();
          }
          return singleton;
    };

    return SupportCenter;

});
